<template>
  <div class="info main_center">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>

    <div style="width: 100%; height: 68px;"></div>

    <div class="content">
      <div class="title">{{ detail.title }}</div>
      <br />
      <div v-html="detail.content"></div>
    </div>

    <el-row v-if="detail.fileList.length" class="content">
      <el-col :key="index" :span="24" v-for="(item, index) in detail.fileList">
        <el-form>
          <el-form-item :label="item.fileTypeName ? (item.fileTypeName + '：') : '附件：'"
            :prop="'attachments' + item.fileType" size="small">
            <affix-msg :showDetail="true" :docItem.sync="item" :docName.sync="item.name" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import affixMsg from "@/components/affixMsg";
import {
  portalSystemDetail,
} from "@/server/mainCredit.js";

export default {
  components: { affixMsg },
  data() {
    return {
      detail: {
        fileList:[]
      },
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.detail.id = this.$route.query.id;
      portalSystemDetail(this.$route.query.id).then((res) => {
        if (res.data.code == 1) {
          this.detail = { ...this.detail, ...res.data.data };
          this.getAttachmentsData();
        }
      });
    }
  },

  methods: {
    getAttachmentsData() {
      this.$httpReq
        .get(
          `/attachment/getDataByCodeAndEid?categoryCode=portal_credit_system_att&entityId=${this.$route.query.id}`
        )
        .then(({ data }) => {
          if (data.code == 1) {
            this.detail.attachments = data.data;
            for (let i = 0; i < data.data[0].attFiles.length; i += 1) {
              this.fileChange(
                {
                  ...data.data[0],
                  ...data.data[0].attFiles[i],
                },
                "add"
              );
            }
          }
        });
    },

    fileChange(files, flag) {
      if (flag == "add") {
        this.detail.fileList.push({
          hideLable: true,
          ...files,
        });
      } else if (flag == "del") {
        let dataList = this.detail.fileList;
        if (files.id) {
          this.deleteFile(files.id);
        }
        let result = dataList.filter((item) => {
          if (item.uid && files.uid) {
            return item.uid != files.uid;
          }
          if (item.id && files.id) {
            return item.id != files.id;
          }
          return true;
        });
        this.detail.fileList = result;
      }
    },

    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: "portalCreditSystem",
        query: {},
      });
    },
  },

}
</script>
<style scoped>
.content {
  background-color: #FFF;
  margin: 12px;
  padding: 24px;
}

.title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
</style>